import { configureStore } from "@reduxjs/toolkit";
import { Buffer } from "buffer";
Buffer.from("anything", "base64");
window.Buffer = window.Buffer || require("buffer").Buffer;
const STORAGE_KEY = process.env.REACT_APP_STORAGE_KEY;

interface Props {
    file: any,
    bucketName: 'compliance-docs-targhee' | 'mytest1-docs',
    fileId: string
    folderName:string
}

const S3Upload = ({ file, fileId, bucketName }: Props) => {
    console.log("Upload triggered Upload triggered Upload triggered");
    return new Promise(async function (resolve, reject) {
        const formData: any = new FormData();
        formData.append("file", file);
        formData.append("fileId", fileId);
        console.log("Upload triggeredb");
        try {
            const url: string = `${process.env.REACT_APP_FLASK_SERVER_URL}/upload-docs`;
            let dbNameToken: any = localStorage.getItem(`${STORAGE_KEY}/dbName`);
            console.log("dbNameToken1 upload", dbNameToken);
            dbNameToken = dbNameToken.replace(/["]/g, '')

            console.log("dbNameToken upload", dbNameToken);
            
            const response = await fetch(url, { method: 'POST', body: formData, headers: { 'DbName':  dbNameToken }});
            const responseData = await response.json();

            if (response.status === 200) {
                console.log("File uploaded successfully", responseData);
                resolve({ status: 200, response });
            } else {
                console.log("File uploaded unsuccessfully", responseData);
                reject({ status: 400, msg: 'Failed to upload file1', error: responseData });
            }
        } catch (error: any) {
            console.log("File uploaded unsuccessfully", 'error');

            reject({ status: 400, msg: 'Failed to upload file2', error: error });
        }
    });
}

//Enterpirse apps  S3 upload 
const S3UploadQuestionnaire_Enterpriseapps = ({ file, fileId, bucketName, folderName }: Props) => {
    console.log("[S3_UPLOAD] Starting questionnaire file upload");
    console.log("[S3_UPLOAD] Parameters:", { 
        fileName: file?.name, 
        fileSize: file?.size, 
        fileType: file?.type,
        fileId, 
        bucketName, 
        folderName 
    });
    
    return new Promise(async function (resolve, reject) {
        try {
            const formData: any = new FormData();
            formData.append("file", file);
            formData.append("fileId", fileId);
            formData.append("bucketName", bucketName);
            formData.append("folderName", folderName);
            
            console.log("[S3_UPLOAD] FormData created with:", {
                hasFile: !!file,
                fileId,
                bucketName,
                folderName
            });
            
            const url: string = `${process.env.REACT_APP_FLASK_SERVER_URL}/enterpriseapps-questionnaire-uploadfile`;
            console.log("[S3_UPLOAD] Upload URL:", url);
            
            let dbNameToken: any = localStorage.getItem(`${STORAGE_KEY}/dbName`);
            console.log("[S3_UPLOAD] Raw dbNameToken from storage:", dbNameToken);
            
            if (dbNameToken) {
                dbNameToken = dbNameToken.replace(/["]/g, '');
            }
            console.log("[S3_UPLOAD] Processed dbNameToken:", dbNameToken);
            
            console.log("[S3_UPLOAD] Sending request to Flask server...");
            const response = await fetch(url, { 
                method: 'POST', 
                body: formData, 
                headers: { 'DbName': dbNameToken || '' }
            });
            
            console.log("[S3_UPLOAD] Response received:", {
                status: response.status,
                statusText: response.statusText,
                ok: response.ok,
                headers: Object.fromEntries(response.headers.entries())
            });
            
            let responseData;
            const contentType = response.headers.get('content-type');
            console.log("[S3_UPLOAD] Response content-type:", contentType);
            
            try {
                if (contentType && contentType.includes('application/json')) {
                    responseData = await response.json();
                } else {
                    const text = await response.text();
                    console.log("[S3_UPLOAD] Non-JSON response text:", text);
                    try {
                        responseData = JSON.parse(text);
                    } catch (e) {
                        responseData = { rawText: text };
                    }
                }
                console.log("[S3_UPLOAD] Parsed response data:", responseData);
            } catch (parseError: any) {
                console.error("[S3_UPLOAD] Error parsing response:", parseError);
                const text = await response.text().catch(() => 'Unable to read response');
                responseData = { parseError: parseError.message, rawResponse: text };
            }

            if (response.status === 200) {
                console.log("[S3_UPLOAD] ✅ File uploaded successfully", responseData);
                resolve({ status: 200, response });
            } else {
                console.error("[S3_UPLOAD] ❌ File upload failed:", {
                    status: response.status,
                    statusText: response.statusText,
                    responseData
                });
                reject({ 
                    status: response.status, 
                    msg: `Failed to upload file (HTTP ${response.status})`, 
                    error: responseData 
                });
            }
        } catch (error: any) {
            console.error("[S3_UPLOAD] ❌ Exception during upload:", {
                errorName: error?.name,
                errorMessage: error?.message,
                errorStack: error?.stack,
                error
            });
            reject({ 
                status: 400, 
                msg: `Failed to upload file: ${error?.message || 'Unknown error'}`, 
                error: error 
            });
        }
    });
}

const S3UploadQuestionnairePDF_Enterpriseapps = ({ companyId, file, fileId, vendorName, bucketName, folderName }: EnterpriseProps) => {
    console.log("Upload triggered for PDF Questionnaire");
    return new Promise(async function (resolve, reject) {
        const formData: any = new FormData();
        formData.append("file", file);
        formData.append("fileId", fileId);
        formData.append("vendor_name", vendorName);
        formData.append("bucketName", bucketName);
        formData.append("folderName", folderName);
        formData.append("companyId", companyId);
        try {
            const url: string = `${process.env.REACT_APP_FLASK_SERVER_URL}/enterpriseapps-questionnaire-pdf-uploadfile`;
            let dbNameToken: any = localStorage.getItem(`${STORAGE_KEY}/dbName`);
            console.log("dbNameToken1 upload", dbNameToken);
            dbNameToken = dbNameToken.replace(/["]/g, '')

            console.log("dbNameToken upload", dbNameToken);
            
            const response = await fetch(url, { method: 'POST', body: formData, headers: { 'DbName':  dbNameToken }});
            const responseData = await response.json();

            if (response.status === 200) {
                console.log("PDF Questionnaire file uploaded successfully", responseData);
                resolve({ status: 200, response });
            } else {
                console.log("PDF Questionnaire file uploaded unsuccessfully", responseData);
                reject({ status: 400, msg: 'Failed to upload file1', error: responseData });
            }
        } catch (error: any) {
            console.log("PDF Questionnaire file uploaded unsuccessfully", 'error');

            reject({ status: 400, msg: 'Failed to upload file2', error: error });
        }
    });
}
interface EnterpriseProps {
    file: any;
    bucketName: 'compliance-docs-targhee' | 'mytest1-docs';
    fileId: string;
    vendorName?:string;
    folderName?:string;
    companyId?:string;
}
const S3UploadComplaince_Enterpriseapps = ({companyId, file, fileId, vendorName, bucketName, folderName }: EnterpriseProps) => {
    console.log("Upload triggered Upload triggered Upload triggered");
    return new Promise(async function (resolve, reject) {
        const formData: any = new FormData();
        formData.append("file", file);
        formData.append("fileId", fileId);
        formData.append("vendor_name", vendorName);
        formData.append("bucketName", bucketName);
        formData.append("folderName", folderName);
        formData.append("companyId", companyId);
        console.log("Upload triggeredb");
        try {
            const url: string = `${process.env.REACT_APP_FLASK_SERVER_URL}/enterpriseapps-compliance-uploadfile`;
            let dbNameToken: any = localStorage.getItem(`${STORAGE_KEY}/dbName`);
            console.log("dbNameToken1 upload", dbNameToken);
            dbNameToken = dbNameToken.replace(/["]/g, '')
            
            const response = await fetch(url, { method: 'POST', body: formData, headers: { 'DbName':  dbNameToken }});
            const responseData = await response.json();

            if (response.status === 200) {
                console.log("File uploaded successfully", responseData);
                resolve({ status: 200, response });
            } else {
                console.log("File uploaded unsuccessfully", responseData);
                reject({ status: 400, msg: 'Failed to upload file1', error: responseData });
            }
        } catch (error: any) {
            console.log("File uploaded unsuccessfully", 'error');

            reject({ status: 400, msg: 'Failed to upload file2', error: error });
        }
    });
}


export const hasSubdomain = (hostname: string): boolean => {
    const parts = hostname.split('.');
    // A typical domain has at least two parts (e.g., example.com)
    // If there are more than two parts, it means there's a subdomain (e.g., sub.example.com)
    return parts.length > 2;
};

interface Props2 { fileKey: string, bucketName: string, newFileName?: string, downlodFile?: boolean }
const S3Download = ({ fileKey, bucketName, newFileName, downlodFile = true }: Props2) => {
    return new Promise(async function (resolve, reject) {
        try {
            let dbNameToken: any = localStorage.getItem(`${STORAGE_KEY}/dbName`);
            const userAccessEmail: any = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_STORAGE_KEY}/userAccessEmail`) || '{}');

            try {
                dbNameToken = dbNameToken.replace(/["]/g, '');
            } catch (e) {}

            const hostname = window.location.hostname;
            if (hasSubdomain(hostname)) {
                dbNameToken = hostname;
            }

            const baseUrl = `${process.env.REACT_APP_FLASK_SERVER_URL}/download-docs`;
            const response = await fetch(baseUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'DbName': dbNameToken
                },
                body: JSON.stringify({
                    bucketName,
                    fileKey,
                    newFileName,
                    userAccessEmail
                }),
            });

            if (response.ok) {
                const blob = await response.blob(); // ✅ handle binary
                const downloadUrl = window.URL.createObjectURL(blob);

                if (downlodFile === true) {
                    const link = document.createElement("a");
                    link.href = downloadUrl;
                    link.download = newFileName || 'default_filename.pdf';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    link.remove();
                }

                resolve({ status: 200 });
            } else {
                const errorData = await response.text(); // safer than .json()
                reject({ status: response.status, msg: 'Download failed', error: errorData });
            }
        } catch (error) {
            reject({ status: 500, msg: 'Download failed', error });
        }
    });
}

interface Props3 { fileKey: string, bucketName: string,folderName:string, newFileName?: string, downlodFile?: boolean }
const S3DownloadForEnterprise = ({ fileKey, bucketName, newFileName,folderName, downlodFile = true }: Props3) => {
    console.log(fileKey);
    return new Promise(async function (resolve, reject) {
        try {
            let dbNameToken: any = localStorage.getItem(`${STORAGE_KEY}/dbName`);
            try{
                dbNameToken = dbNameToken.replace(/["]/g, '')
            } catch(e){}

            const hostname = window.location.hostname;
            if (hasSubdomain(hostname)) {
                dbNameToken = window.location.hostname;
            }
            
            const baseUrl = `${process.env.REACT_APP_FLASK_SERVER_URL}/download-docs-enterprise-apps`;
            const response = await fetch(baseUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'DbName':  dbNameToken 
                },
                body: JSON.stringify({
                    bucketName,
                    fileKey,
                    newFileName,
                    folderName
                }),
            });

            const responseData = await response.json();
            if (response.ok) {
                const downloadUrl = responseData.url;
                if (downlodFile === true) {
                    const link: any = document.createElement("a");
                    link.download = newFileName;
                    link.href = downloadUrl;
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    link.remove();
                }
                resolve({ status: 200, responseData });
            } else {
                reject({ status: response.status, msg: 'Failed to generate download URL', error: responseData });
            }
        } catch (error) {
            reject({ status: 500, msg: 'Failed to generate download URL', error: error });
        }
    });

    
}

/** Payload for /downloadQuestionnaire. Backend only requires questions, bucketName, and fileName. */
interface QuestionnaireObj {
    questions: {
        question: string;
        answer: string;
    }[];
    bucketName: string;
    fileName: string;       // downloadable name (e.g. .xlsx for Excel output)
    fileId?: string;        // optional; not used by Flask for questionnaire Excel
    fileAndFolder?: string; // optional; not used by Flask for questionnaire Excel
}

const S3DownloadForEnterpriseQuestionnaire = ({ obj }: { obj: QuestionnaireObj }) => {
    return new Promise(async (resolve, reject) => {
        try {
            let dbNameToken: any = localStorage.getItem(`${STORAGE_KEY}/dbName`);
            if (dbNameToken) {
                dbNameToken = dbNameToken.replace(/["]/g, '');
            }

            const hostname = window.location.hostname;
            if (hasSubdomain(hostname)) {
                dbNameToken = hostname;
            }

            const baseUrl = `${process.env.REACT_APP_FLASK_SERVER_URL}/downloadQuestionnaire`;

            const response = await fetch(baseUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'DbName': dbNameToken
                },
                body: JSON.stringify(obj)
            });

            const responseData = await response.json();

            if (response.ok) {
                const downloadUrl = responseData.url;

                const link = document.createElement("a");
                link.href = downloadUrl;
                link.download = obj.fileName || 'Questionnaire_with_Answers.xlsx';
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                resolve({ status: 200, responseData });
            } else {
                reject({
                    status: response.status,
                    msg: 'Failed to generate download URL',
                    error: responseData
                });
            }
        } catch (error) {
            reject({
                status: 500,
                msg: 'Failed to generate download URL',
                error
            });
        }
    });
};



interface Props4 { bucketName: string, fileName: string, fileId:string}
const S3DownloadForLLMQuestionReview = ({bucketName, fileName, fileId}: Props4) => {
    return new Promise(async function (resolve, reject) {
        try {
            let dbNameToken: any = localStorage.getItem(`${STORAGE_KEY}/dbName`);
            try{
                dbNameToken = dbNameToken.replace(/["]/g, '')
            } catch(e){}

            const hostname = window.location.hostname;
            if (hasSubdomain(hostname)) {
                dbNameToken = window.location.hostname;
            }
            
            const baseUrl = `${process.env.REACT_APP_FLASK_SERVER_URL}/download-source-llm-question-review`;
            const response = await fetch(baseUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'DbName':  dbNameToken 
                },
                body: JSON.stringify({
                    bucketName,
                    fileName,
                    fileId
                }),
            });

            const responseData = await response.json();
            if (response.ok) {
                const downloadUrl = responseData.url;
                const link: any = document.createElement("a");
                    link.download = fileName;
                    link.href = downloadUrl;
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    link.remove();
                resolve({ status: 200, responseData });
            } else {
                reject({ status: response.status, msg: 'Failed to generate download URL', error: responseData });
            }
        } catch (error) {
            reject({ status: 500, msg: 'Failed to generate download URL', error: error });
        }
    });
}

interface Props5 { bucketName: string, fileName: string, fileId: string, folderName: string, }
const S3DownloadForInboundAttachments = ({bucketName, fileName, fileId, folderName}: Props5) => {
    return new Promise(async function (resolve, reject) {
        try {

            
            const baseUrl = `${process.env.REACT_APP_FLASK_SERVER_URL}/download-inbound-attachments`;
            const response = await fetch(baseUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    
                },
                body: JSON.stringify({
                    bucketName,
                    fileName,
                    fileId,
                    folderName
                }),
            });

            const responseData = await response.json();
            if (response.ok) {
                const downloadUrl = responseData.url;
                const link: any = document.createElement("a");
                link.download = fileName;
                link.href = downloadUrl;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                link.remove();
                resolve({ status: 200, responseData });
            } else {
                reject({ status: response.status, msg: 'Failed to generate download URL', error: responseData });
            }
        } catch (error) {
            reject({ status: 500, msg: 'Failed to generate download URL', error: error });
        }
    });
}

const S3DeleteInboundAttachments = ({bucketName, fileName, fileId, folderName}: Props5) => {
    return new Promise(async function (resolve, reject) {
        try {
            let dbNameToken: any = localStorage.getItem(`${STORAGE_KEY}/dbName`);
            try{
                dbNameToken = dbNameToken.replace(/["]/g, '')
            } catch(e){}

            const hostname = window.location.hostname;
            if (hasSubdomain(hostname)) {
                dbNameToken = window.location.hostname;
            }
            
            const baseUrl = `${process.env.REACT_APP_FLASK_SERVER_URL}/delete-inbound-attachments`;
            const response = await fetch(baseUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'DbName':  dbNameToken 
                },
                body: JSON.stringify({
                    bucketName,
                    fileName,
                    fileId,
                    folderName
                }),
            });

            const responseData = await response.json();
            if (response.ok) {
                resolve({ status: 200, responseData });
            } else {
                reject({ status: response.status, msg: 'Failed to delete file', error: responseData });
            }
        } catch (error) {
            reject({ status: 500, msg: 'Failed to delete file', error: error });
        }
    });
}

export { S3Upload, S3Download,S3UploadComplaince_Enterpriseapps, S3DownloadForEnterprise, S3DownloadForEnterpriseQuestionnaire,S3UploadQuestionnaire_Enterpriseapps, S3UploadQuestionnairePDF_Enterpriseapps, S3DownloadForLLMQuestionReview, S3DownloadForInboundAttachments, S3DeleteInboundAttachments };